import type { TaxReturn, Voucher } from '@/_types/models/taxReturns';
import { moment } from '@/_utils/dates';

export const getCompletedPaymentCount = (taxReturn: TaxReturn): number => {
  const isInvoicePaid: boolean = taxReturn?.payment?.status === 'paid';

  return (
    taxReturn.payment_vouchers.filter(
      (voucher) => voucher.is_paid && !voucher.is_instruction_page,
    ).length + (isInvoicePaid ? 1 : 0)
  );
};

export const getTotalPaymentCount = (taxReturn: TaxReturn): number => {
  return (
    taxReturn.payment_vouchers.filter((voucher) => !voucher.is_instruction_page)
      .length + (taxReturn.payment ? 1 : 0)
  );
};

export const getRemainingPaymentCount = (taxReturn: TaxReturn): number =>
  getTotalPaymentCount(taxReturn) - getCompletedPaymentCount(taxReturn);

export const getDueDate = (voucher: Voucher): string => {
  if (voucher.is_due_asap) {
    return 'ASAP';
  } else if (!voucher.due_date) {
    return 'Not specified';
  } else {
    return moment(voucher.due_date).format('MMM D, YYYY');
  }
};
